
// Reminder Action Types

export const ADD_REMINDER = 'ADD_REMINDER'
export const REMOVE_REMINDER = 'REMOVE_REMINDER'
export const CLEAR_REMINDER = 'CLEAR_REMINDER'